
import React from 'react';
import { useTheme } from '../context/ColorContext';

const KVKK = () => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <div className={`min-h-screen pt-32 pb-20 px-4 md:px-0 container mx-auto max-w-4xl ${isDark ? 'text-white' : 'text-slate-900'}`}>
            <h1 className="text-4xl md:text-6xl font-black uppercase mb-12 tracking-tighter">Kişisel Verilerin Korunması (KVKK)</h1>

            <div className="space-y-8 opacity-80 text-lg font-light leading-relaxed">
                <section>
                    <h2 className="text-2xl font-bold uppercase mb-4 text-[#5AA668]">1. Veri Sorumlusu</h2>
                    <p>
                        6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca, kişisel verileriniz; veri sorumlusu olarak Kayalar Kimya San. ve Tic. A.Ş. (“DÜFA” veya “Şirket”) tarafından aşağıda açıklanan kapsamda işlenebilecektir.
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-bold uppercase mb-4 text-[#5AA668]">2. Kişisel Verilerin İşlenme Amacı</h2>
                    <p>
                        Toplanan kişisel verileriniz, Şirketimiz tarafından sunulan ürün ve hizmetlerden sizleri faydalandırmak için gerekli çalışmaların iş birimlerimiz tarafından yapılması; Şirketimiz tarafından sunulan ürün ve hizmetlerin sizlerin beğeni, kullanım alışkanlıkları ve ihtiyaçlarına göre özelleştirilerek sizlere önerilmesi; Şirketimizin ve Şirketimizle iş ilişkisi içerisinde olan kişilerin hukuki ve ticari güvenliğinin temini; Şirketimizin ticari ve iş stratejilerinin belirlenmesi ve uygulanması amaçlarıyla işlenmektedir.
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-bold uppercase mb-4 text-[#5AA668]">3. İşlenen Kişisel Verilerin Kimlere ve Hangi Amaçla Aktarılabileceği</h2>
                    <p>
                        Toplanan kişisel verileriniz; yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda; iş ortaklarımıza, tedarikçilerimize, kanunen yetkili kamu kurumlarına ve özel kişilere, KVKK’nın 8. ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları çerçevesinde aktarılabilecektir.
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-bold uppercase mb-4 text-[#5AA668]">4. Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi</h2>
                    <p>
                        Kişisel verileriniz Şirketimiz tarafından farklı kanallar ve farklı hukuki sebeplere dayanarak; sunduğumuz ürün ve hizmetleri geliştirmek ve ticari faaliyetlerimizi yürütmek amacıyla toplanmaktadır. Bu süreçte toplanan kişisel verileriniz; fiziki veya elektronik ortamda, KVKK’nın 5. ve 6. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları kapsamında işlenebilmekte ve aktarılabilmektedir.
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-bold uppercase mb-4 text-[#5AA668]">5. Kişisel Veri Sahibinin Hakları</h2>
                    <p>
                        Kişisel veri sahibi olarak Kanun’un 11. maddesi uyarınca aşağıdaki haklara sahip olduğunuzu bildiririz:
                    </p>
                    <ul className="list-disc ml-6 mt-4 space-y-2">
                        <li>Kişisel veri işlenip işlenmediğini öğrenme,</li>
                        <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</li>
                        <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
                        <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,</li>
                        <li>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme,</li>
                        <li>KVKK ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerin silinmesini veya yok edilmesini isteme.</li>
                    </ul>
                </section>
            </div>
        </div>
    );
};

export default KVKK;
